import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { register } from '../../services/authService';
import './AuthPages.css';

const initial = {
  username: '',
  password: '',
  email: '',
  firstName: '',
  lastName: '',
  phone: '',
  streetAddress: '',
  city: '',
  state: '',
  zip: '',
};

export default function Register() {
  const [form, setForm] = useState(initial);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const onChange = (field) => (e) => {
    setForm((f) => ({ ...f, [field]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);
    try {
      const payload = {
        username: form.username.trim(),
        password: form.password,
        email: form.email.trim(),
        firstName: form.firstName.trim(),
        lastName: form.lastName.trim(),
        phone: form.phone.trim(),
        streetAddress: form.streetAddress.trim(),
        city: form.city.trim(),
        state: form.state.trim(),
        zip: form.zip.trim(),
      };
      await register(payload);
      setSuccess('Registration submitted. An administrator must approve your account before you can sign in.');
    } catch (err) {
      const msg =
        err.response?.data?.message ||
        err.response?.data?.error ||
        err.message ||
        'Registration failed.';
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card auth-register-wide">
        <h1>Request access</h1>
        <p className="auth-card__lead">
          Create an account. An admin must approve you before you can sign in. You can add passport and SSN later in
          your profile if needed.
        </p>
        {error ? <div className="auth-error">{error}</div> : null}
        {success ? (
          <div className="auth-card__lead" style={{ color: '#166534', marginBottom: '1rem' }}>
            {success}{' '}
            <Link to="/login">Continue to sign in</Link>
          </div>
        ) : null}
        <form onSubmit={handleSubmit} style={{ display: success ? 'none' : undefined }}>
          <div className="auth-field">
            <label htmlFor="reg-username">Username</label>
            <input id="reg-username" value={form.username} onChange={onChange('username')} required minLength={3} />
          </div>
          <div className="auth-field">
            <label htmlFor="reg-password">Password (min 10 characters)</label>
            <input
              id="reg-password"
              type="password"
              value={form.password}
              onChange={onChange('password')}
              required
              minLength={10}
            />
          </div>
          <div className="auth-field">
            <label htmlFor="reg-email">Email</label>
            <input id="reg-email" type="email" value={form.email} onChange={onChange('email')} required />
          </div>
          <div className="auth-field">
            <label htmlFor="reg-first">First name</label>
            <input id="reg-first" value={form.firstName} onChange={onChange('firstName')} required />
          </div>
          <div className="auth-field">
            <label htmlFor="reg-last">Last name</label>
            <input id="reg-last" value={form.lastName} onChange={onChange('lastName')} required />
          </div>
          <div className="auth-field">
            <label htmlFor="reg-phone">Phone</label>
            <input id="reg-phone" value={form.phone} onChange={onChange('phone')} required />
          </div>
          <div className="auth-field">
            <label htmlFor="reg-street">Street</label>
            <textarea
              id="reg-street"
              rows={2}
              value={form.streetAddress}
              onChange={onChange('streetAddress')}
              required
              autoComplete="street-address"
            />
          </div>
          <div className="auth-field">
            <label htmlFor="reg-city">City</label>
            <input id="reg-city" value={form.city} onChange={onChange('city')} required autoComplete="address-level2" />
          </div>
          <div className="auth-field">
            <label htmlFor="reg-state">State / region</label>
            <input id="reg-state" value={form.state} onChange={onChange('state')} required autoComplete="address-level1" />
          </div>
          <div className="auth-field">
            <label htmlFor="reg-zip">ZIP / postal code</label>
            <input id="reg-zip" value={form.zip} onChange={onChange('zip')} required autoComplete="postal-code" />
          </div>
          <div className="auth-actions">
            <button type="submit" disabled={loading}>
              {loading ? 'Submitting…' : 'Submit registration'}
            </button>
            <Link to="/login">Back to sign in</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
